import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Announces that a dashboard was created, changed or deleted, so views that keep their own copy of the
 * list (the products' menus) load it again (WB-185). Provided in root on purpose: `DashboardApiService`
 * is provided per module and may exist more than once, while every view has to hear the same changes.
 * Standalone and store-free so the tenants can import it by its deep path.
 */
@Injectable({ providedIn: 'root' })
export class DashboardChangesService {
  private readonly changed = new Subject<void>();

  /** Emits after every saved dashboard change. */
  readonly changes: Observable<void> = this.changed.asObservable();

  notify(): void {
    this.changed.next();
  }
}
